require('./angular/dependencies');

const { default: startApp, defaultRun } = require('./angular/avant');
const { renderReact } = require('./angular/react');

startApp(defaultRun(renderReact));

window.angular = angular;
